import { version } from "@internal/package";
import { defineEvent, defineStore } from "@otto-ec/global-resources/nexus";
import { toggle } from "@otto-ec/global-resources/toggle";
import { waitForMount } from "@otto-ec/otto-components-utils/utils/waitForMount";
import { components } from "./common/component";
import { setColorScheme } from "./common/theme.js";
import "./global-event-handler/index.js";

/*                                                                         */
import.meta.glob(["./components/**/*.async.svelte"], {
  eager: true,
});

/*                               */
import.meta.glob("./components/**/*.component.ts", {
  eager: true,
});

if (
  import.meta.env.VITE_BUILD_ENVIRONMENT_TARGET === "develop" &&
  !import.meta.env.STORYBOOK &&
  toggle.get("oc_darkmode_toggle_enabled")
) {
  import("./common/components/DarkmodeToggle/DarkmodeToggle.testing.js");
}

/*                                                     */
const apis = Object.entries(
  import.meta.glob<true, string, Record<string, unknown>>(["./components/**/*.api.ts"], {
    eager: true,
  }),
).map(([path, module]) => {
  const name = path.match(/\/([^/]+)\.api\.ts$/)?.[1];

  if (import.meta.env.DEV && !name) {
    throw new Error(`Could not parse component name from path: ${path}`);
  }

  const key = name![0].toLowerCase() + name!.slice(1);
  const api = module[key];

  if (import.meta.env.DEV && !api) {
    throw new Error(`Module ${path} does not export ${key}`);
  }

  return { [key]: api };
});

components.assignNamespace(
  Object.assign(
    {
      version: () => version,
      setColorScheme,
      asyncComponentsLoaded: defineStore(true),
      waitForMount,
      __onAttachShadow: defineEvent(),
    },
    ...apis,
  ),
);
